import { BaseModel } from './base-model';

export class NotificationPushRegistrationModel extends BaseModel {
  registrationId: string;
  handle: string;
  platform: number;
  tags: string[];
}
